<template>
  <UiModal
    title="Adaug o recenzie"
    :subtitle="currentDate"
    :buttons="buttons"
    @submit="sendFeedback"
    @close="closeModal"
  >
    <template slot="body">
      <div class="feedback">
        <div class="feedback__heading feedback__heading--center">
          Ofera o nota expeirentei tale cu <br />
          "<span>{{specialistName || specialist.full_name}}</span>"
        </div>
        <div class="feedback__star-group">
          <i
            class="fas fa-star"
            :class="{ active: this.rating > 4 }"
            @click="setRating(5)"
          ></i>
          <i
            class="fas fa-star"
            :class="{ active: this.rating > 3 }"
            @click="setRating(4)"
          ></i>
          <i
            class="fas fa-star"
            :class="{ active: this.rating > 2 }"
            @click="setRating(3)"
          ></i>
          <i
            class="fas fa-star"
            :class="{ active: this.rating > 1 }"
            @click="setRating(2)"
          ></i>
          <i
            class="fas fa-star"
            :class="{ active: this.rating != null }"
            @click="setRating(1)"
          ></i>
        </div>
        <textarea
          class="feedback__textarea"
          placeholder="Care a fost experienta dvs. ?"
          @input="validateReview($event.target.value)"
        ></textarea>
        <div
          class="feedback__validation"
          :class="{ 'feedback__validation--visible': displayValidation }"
        >
          *Recenziile text sunt necesare pentru a continua!
        </div>
      </div>
    </template>
  </UiModal>
</template>

<script>
import UiModal from "@/components/ui/Modal";
import * as moment from "moment";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";


export default {
  components: {
    UiModal,
  },
  data: function () {
    return {
      buttons: [
        {
          event: "submit",
          text: "Posteaza recenzia",
          style: "",
          disabled: true,
        },
      ],
      rating: null,
      review: "",
      specialistName: "",
      displayValidation: false,
    };
  },
  methods: {
    ...mapActions({
        storeFeedback: 'specialist/storeFeedback'
    }),
    sendFeedback() {
      if (!this.buttons[0].disabled) {
        var data = {
          specialistId: this.specialist.id,
          stars: this.rating,
          description: this.review,
        };
        this.storeFeedback(data);
        this.closeModal();
      }
    },
    validateData() {
      if (
        this.rating != null &&
        this.review.length > 0 &&
        this.review != null
      ) {
        this.buttons[0].disabled = false;
        this.displayValidation = false;
      } else this.buttons[0].disabled = true;
    },
    validateReview(text) {
      this.review = text;
      console.log(text);
      if (text.length == 0 || text == null)
        this.displayValidation = true;

      this.validateData();
    },
    setRating(value) {
      this.rating = value;
      this.validateData();
    },
    closeModal(){
        this.$store.state.specialist.modals.addFeedback = false;
    }
  },
  computed: {
    ...mapGetters({
      specialist: "specialist/specialist",
    }),
    currentDate: function () {
      return moment().format("LL");
    },
  },
  watch:{
      '$store.state.specialist.specialist': function(newValue, oldValue){
          this.specialistName = newValue.full_name;
      }
  }
};
</script>
<style lang="scss" scoped>
    //feedback

    ::v-deep .feedback{ //targets child components ** very useful
        display: flex;
        flex-direction: column;

        &__heading{
            font-weight: 500;
            font-size: 18px;
            line-height: 20px;
            width: 100%;
            margin-top: 30px;

            &--center{
                text-align: center;
            }

            span {
                color: $color-primary;
            }
        }

        &__star-group{
            flex-direction: row-reverse;
            display: flex;
            font-size: 40px;
            justify-content: space-between;
            max-width: 280px;
            width: 280px;
            color: rgba($color-main-text, 0.25);
            margin: 35px auto 0px auto;

            i{
                cursor: pointer;
            }

            i.active{
                color: #FED44C;
            }

            i:hover, i:hover ~ *{
                color: #FED44C;
            }
        }

        &__textarea{
            background: #FFFFFF;
            box-sizing: border-box;
            box-shadow: 0 3px 3px -2px rgba(0,0,0,0.2), 0 3px 4px 0 rgba(0,0,0,0.14), 0 1px 8px 0 rgba(0,0,0,0.12);
            width: 95%;
            min-height: 80px;
            outline: none;
            padding: 10px;
            border: 1px solid rgba($color-main-text, 0.25);
            margin: 35px auto 0px auto;

            &:focus{
                border: 1px solid #07EBD0;
            }

            &::placeholder{
                opacity: 0.25;
            }
        }

        &__validation{
            font-family: 'Roboto', sans-serif;
            font-size: 12px;
            line-height: 20px;
            color: $color-danger;
            margin: 10px 2.5% 10px 2.5%;
            visibility: hidden;

            &--visible{
                visibility: visible;
            }
        }
    }
</style>